import React from 'react';
import { Link } from 'react-router-dom';

// scss
import './FloorMap.scss';

type Props = {
  active: number, 
}

const FloorMap4: React.FC<Props> = (props) => {
  return (
    <div id="FloorMap4">
      <div className="wrapper">
        <div className="leftArea">
          <div className="bg1">
            <ul>
              <li className={props.active===110 ? 'area0 active' : 'area0'}><Link to={'/digital/fair2021/showroom/floor4/area11.html'} /></li>
              <li className={props.active===109 ? 'area1 active' : 'area1'}><Link to={'/digital/fair2021/showroom/floor4/area10.html'} /></li>
              <li className={props.active===106 ? 'area2 active' : 'area2'}><Link to={'/digital/fair2021/showroom/floor4/area07.html'} /></li>
              <li className={props.active===105 ? 'area3 active' : 'area3'}><Link to={'/digital/fair2021/showroom/floor4/area06.html'} /></li>
              <li className={props.active===108 ? 'area4 active' : 'area4'}><Link to={'/digital/fair2021/showroom/floor4/area09.html'} /></li>
              <li className={props.active===112 ? 'area5 active' : 'area5'}><Link to={'/digital/fair2021/showroom/floor4/area13.html'} /></li>
              <li className={props.active===107 ? 'area6 active' : 'area6'}><Link to={'/digital/fair2021/showroom/floor4/area08.html'} /></li>
              <li className={props.active===102 ? 'area7 active' : 'area7'}><Link to={'/digital/fair2021/showroom/floor4/area03.html'} /></li>
              <li className={props.active===104 ? 'area8 active' : 'area8'}><Link to={'/digital/fair2021/showroom/floor4/area05.html'} /></li>
              <li className={props.active===103 ? 'area9 active' : 'area9'}><Link to={'/digital/fair2021/showroom/floor4/area04.html'} /></li>
              <li className={props.active===101 ? 'area10 active' : 'area10'}><Link to={'/digital/fair2021/showroom/floor4/area02.html'} /></li>
              <li className={props.active===100 ? 'area11 active' : 'area11'}><Link to={'/digital/fair2021/showroom/floor4/area01.html'} /></li>
              <li className={props.active===111 ? 'area12 active' : 'area12'}><Link to={'/digital/fair2021/showroom/floor4/area12.html'} /></li>
            </ul>
          </div>
        </div>
        {/* <div className="floorMapNavi hidePc">
          <ul>
          <li><Link to={'/digital/fair2021/showroom/floor4/area10.html'}><span>1</span>デスク</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area09.html'}><span>2</span>ワークステーション</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area07.html'}><span>3</span>オフィスチェアー</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area06.html'}><span>4</span>ホワイトボードスクリーン</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area08.html'}><span>5</span>会議ミーティングコラボレーション</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area12.html'}><span>6</span>防災</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area11.html'}><span>7</span>DAYS OFFICE</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area03.html'}><span>8</span>会議用イス</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area05.html'}><span>9</span>医療</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area04.html'}><span>10</span>教育</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area02.html'}><span>11</span>Plocka / Mycket</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area01.html'}><span>12</span>any</Link></li>
            <li><Link to={'/digital/fair2021/showroom/floor4/area01.html'}><span>13</span>官公庁</Link></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
          </ul> 
        </div> */}
        <div className="rightArea">
          <div className="bg2">
            <ul>
              <li className="area13"><Link to={'/digital/fair2021/showroom/activity.html'} /></li>
            </ul>
          </div>
        </div>
        {/* <div className="floorMapNavi hidePc">
          <ul>
            <li><Link to={'/digital/fair2021/showroom/activity.html'}><span>13</span>7つのアクティビティ</Link></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
            <li className={'blank'}></li>
          </ul> 
        </div> */}
      </div>
      {/* <div className="floorMapNavi hideSp">
        <ul>
          <li><Link to={'/digital/fair2021/showroom/floor4/area10.html'}><span>1</span>デスク</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area09.html'}><span>2</span>ワークステーション</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area07.html'}><span>3</span>オフィスチェアー</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area06.html'}><span>4</span>ホワイトボードスクリーン</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area08.html'}><span>5</span>会議ミーティングコラボレーション</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area12.html'}><span>6</span>防災</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area11.html'}><span>7</span>DAYS OFFICE</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area03.html'}><span>8</span>会議用イス</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area05.html'}><span>9</span>医療</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area04.html'}><span>10</span>教育</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area02.html'}><span>11</span>Plocka / Mycket</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area01.html'}><span>12</span>any</Link></li>
          <li><Link to={'/digital/fair2021/showroom/floor4/area01.html'}><span>13</span>官公庁</Link></li>
          <li><Link to={'/digital/fair2021/showroom/activity.html'}><span>14</span>7つのアクティビティ</Link></li>
          <li className={'blank'}></li>
          <li className={'blank'}></li>
          <li className={'blank'}></li>
          <li className={'blank'}></li>
        </ul> 
      </div> */}
    </div>
  );
}

export default FloorMap4;
